import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface StickyFooterProps {
  children: ReactNode;
  className?: string;
}

export function StickyFooter({ children, className }: StickyFooterProps) {
  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 right-0 z-50',
        'border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60',
        'shadow-lg',
        className
      )}
    >
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-end gap-3">
          {children}
        </div>
      </div>
    </div>
  );
}
